import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.625 4.2168C9.625 5.87365 10.9681 7.2168 12.625 7.2168C14.2819 7.2168 15.625 5.87365 15.625 4.2168C15.625 2.55994 14.2819 1.2168 12.625 1.2168C10.9681 1.2168 9.625 2.55994 9.625 4.2168Z",
			fill: "#395566"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.625 15.2168C10.9681 15.2168 9.625 13.8737 9.625 12.2168C9.625 10.5599 10.9681 9.2168 12.625 9.2168C14.2819 9.2168 15.625 10.5599 15.625 12.2168C15.625 13.8737 14.2819 15.2168 12.625 15.2168Z",
			fill: "#395566"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.625 23.2168C10.9681 23.2168 9.625 21.8737 9.625 20.2168C9.625 18.5599 10.9681 17.2168 12.625 17.2168C14.2819 17.2168 15.625 18.5599 15.625 20.2168C15.625 21.8737 14.2819 23.2168 12.625 23.2168Z",
			fill: "#395566"
		})
	]
});
export default SvgFill;
